// Auto-detect correct backend URL based on current domain
// Always uses window.location.origin in production for reliable routing
// CRITICAL: Never use process.env.REACT_APP_BACKEND_URL directly in production!

/**
 * Get the correct backend URL dynamically.
 * In production, ALWAYS returns window.location.origin to prevent CORS issues.
 */
export const getBackendUrl = () => {
  // In browser context, always use current origin for production domains
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // For localhost development, use env variable or localhost fallback
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    }
    
    // PRODUCTION: Always use same origin to prevent CORS errors
    // This ensures requests go to autohub360.ca when loaded from autohub360.ca
    return window.location.origin;
  }
  
  // SSR/build-time fallback
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const getApiUrl = () => {
  return getBackendUrl() + '/api';
};

/**
 * Validate that a request URL matches the current host.
 * Logs error and returns false if mismatched (helps debug CORS issues).
 */
export const validateRequestHost = (requestUrl) => {
  if (typeof window === 'undefined') return true;
  
  const currentHost = window.location.hostname;
  
  // Skip validation for localhost
  if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
    return true;
  }
  
  try {
    const url = new URL(requestUrl);
    if (url.hostname !== currentHost) {
      console.error(`🚫 [HOST MISMATCH] Request to ${url.hostname} blocked! Expected: ${currentHost}`);
      console.error(`   Full URL: ${requestUrl}`);
      console.error(`   This is likely a stale REACT_APP_BACKEND_URL from build time.`);
      return false;
    }
  } catch (e) {
    // Relative URLs are fine
    return true;
  }
  
  return true;
};

// DEPRECATED: Do not use these static exports - they are evaluated at BUILD TIME
// and will contain stale values in production deployments!
// Always use getBackendUrl() and getApiUrl() functions instead.
export const API_URL = typeof window !== 'undefined' ? getApiUrl() : '';
export const BACKEND_URL = typeof window !== 'undefined' ? getBackendUrl() : '';

